__webpack_require__.p = "/pixel-art-app/";